import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { popularPosts } from '../data/content';

const { FiArrowRight } = FiIcons;

function CuratorSidebar() {
  const [email, setEmail] = useState('');
  const [notice, setNotice] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    setNotice(email.includes('@')
      ? 'Your address is valid, but subscriptions are not being stored yet.'
      : 'Please enter a valid email address.');
  };

  return (
    <aside className="curator-sidebar">
      <section className="curator-card">
        <span className="eyebrow">From the Curator</span>
        <div className="curator-portrait">
          <img
            src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=700&q=85"
            alt="The Girl In Paris curator"
          />
        </div>
        <p className="script-kicker">A note from Paris</p>
        <h3>You are allowed to outgrow the life you once chose.</h3>
        <p>Consider this issue a permission slip—and a companion for whatever comes next.</p>
        <span className="signature">Capucine</span>
      </section>

      <section className="newsletter-card">
        <span className="eyebrow light">Letters from Paris</span>
        <h3>A beautiful note for your Sunday morning.</h3>
        <form onSubmit={handleSubmit}>
          <label htmlFor="newsletter-email">Email address</label>
          <div className="email-field">
            <input
              id="newsletter-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
              required
            />
            <button type="submit" aria-label="Join newsletter">
              <SafeIcon icon={FiArrowRight} />
            </button>
          </div>
          {notice && <p className="form-notice">{notice}</p>}
          <div data-greta-form-placeholder="NEWSLETTER_SIGNUP">This form is not collecting yet.</div>
        </form>
      </section>

      <section className="popular-list">
        <span className="eyebrow">Most Read</span>
        {popularPosts.map((post, index) => (
          <button key={post}>
            <span>0{index + 1}</span>
            <strong>{post}</strong>
          </button>
        ))}
      </section>
    </aside>
  );
}

export default CuratorSidebar;